import { FC, createContext, useState, useContext } from 'react';
import {
  ContentSlotContextPropsType,
  ContentSlotProviderPropsType,
  ComponentRecords,
  ContentSlotRecord,
} from './types/propsType';
//ContentSlot Context
const ContentSlotContext = createContext<ContentSlotContextPropsType>({
  slotMappings: {},
  setSlotMappings: () => 0,
});

const ContentSlotProvider = ({ slotMappings, children }: ContentSlotProviderPropsType) => {
  const [contentSlot, setContentSlot] = useState(slotMappings);
  return (
    <ContentSlotContext.Provider value={{ slotMappings: contentSlot, setSlotMappings: setContentSlot }}>
      {children}
    </ContentSlotContext.Provider>
  );
};

/**
 *
 * @param productKey
 * @param componentKey
 * @param defaultComponent
 * @returns
 */
function useContentSlot<T>(productKey: string, componentKey: string, defaultComponent: FC<T>): FC<T> {
  const { slotMappings } = useContext(ContentSlotContext);
  if (productKey in slotMappings) {
    const componentRecords = slotMappings[productKey];
    if (componentRecords && componentKey in componentRecords) {
      return componentRecords[componentKey] as FC<T>;
    }
    return defaultComponent;
  }
  return defaultComponent;
}
function useContentSlotUpdate(podName: string) {
  const { slotMappings, setSlotMappings } = useContext(ContentSlotContext);
  return (value: ComponentRecords) => setSlotMappings({ ...slotMappings, [podName]: { ...value } });
}

export type { ContentSlotRecord };
export { ContentSlotProvider, useContentSlot, useContentSlotUpdate };
export default ContentSlotProvider;
